import { createAction } from 'redux-act';

export const fetchYear = createAction('fetch year');
export const successFetchYear = createAction('success fetch year');
export const failFetchYear = createAction('fail fetch year');



// WEBPACK FOOTER //
// ./src/actions/year.js